import { useState, useEffect, useCallback, useRef } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage'

const TOOLTIP_PREFIX = 'tooltip_dismissed_'

// In-memory cache to avoid async flicker on re-mount
const dismissedCache: Record<string, boolean> = {}

export const useTooltipDismiss = (key: string) => {
  const [visible, setVisible] = useState(false)
  const loaded = useRef(false)

  useEffect(() => {
    if (loaded.current) return

    // Check memory cache first (instant, no flicker)
    if (dismissedCache[key]) {
      loaded.current = true
      return
    }

    AsyncStorage.getItem(TOOLTIP_PREFIX + key).then((val) => {
      loaded.current = true
      if (val === 'true') {
        dismissedCache[key] = true
      } else {
        setVisible(true)
      }
    })
  }, [key])

  const dismiss = useCallback(() => {
    setVisible(false)
    dismissedCache[key] = true
    AsyncStorage.setItem(TOOLTIP_PREFIX + key, 'true')
  }, [key])

  const reset = useCallback(() => {
    setVisible(true)
    delete dismissedCache[key]
    AsyncStorage.removeItem(TOOLTIP_PREFIX + key)
  }, [key])

  return { visible, dismiss, reset }
}
